module.exports = __webpack_public_path__ + "img/Indonesia.12ab7223.png";